import { render, staticRenderFns } from "./Rotina.vue?vue&type=template&id=88f8e1b2"
import script from "./Rotina.vue?vue&type=script&lang=js"
export * from "./Rotina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports